// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Ps6c","footer":"ModalError_footer__2yDIb"};